import {defineStore} from "pinia";

export const usePermissionStore = defineStore('PermissionStore', {
    state: () => {
        return {
            anabPolicies: new Array<{ Name:string, Roles:string }>()
        }
    },
})
